module.exports = reactBoilerplateDeps;